<template>
	<SOSlotBase
		:container-name="`active-session`"
		:loading="isLoading"
		:bg-grey="true"
	>
		<template v-slot:title-bar>
			<SOTitleBar
			page-title="Sesi Smartowner Aktif"
			:type="'back'"
			@back="back"
			/>
		</template>

		<template v-slot:loading-page>
			<SOLoadingPage />
		</template>

		<template v-slot:content v-if="!isLoading">
			<div>
				<div class="d-flex justify-content-between align-items-center m-2">
					<span class="f-c-midgrey">
						{{ count }} Sesi aktif
					</span>
					<SOButton
						text="Logout Semua"
						outline-danger
						@action="logoutSession('all')"
					/>
				</div>
				<div
					class="card-item m-2"
					v-for="item in data"
					:key="item.id"
				>
					<div class="f-semi f-c-midgrey">
						<div>
							User Login: 
							<span class="elipsis f-c-black f-semi">
								{{ item.karyawan?.nama ?? 'Owner' }}
							</span>
						</div>
						<div class="pb-1">
							Terakhir Login:
							<span class="f-c-black f-semi">
								{{ formattedDate(item.last_login) }}
							</span>
						</div>
						<div>
							User Agent: 
							<span class="elipsis f-c-black f-semi">
								{{ item.user_agent.replaceAll('_', ' ') }}
							</span>
						</div>
					</div>
					<div class="text-right">
						<SOButton
							text="Logout"
							outline-danger
							@action="logoutSession(item.id)"
						/>
					</div>
				</div>
				<SOLoadMoreLoading
					id="loading-list-session"
					:loading="count > (data ?? []).length || isLoadingMore"
					@intersect="getData(true)"
					
				/>
			</div>
		</template>
		<template v-slot:modal>
			<SOModalConfirm
				title="Hapus Sesi"
				:body="deleteBody"
				button-text="Hapus"
				ref="deleteConfirmModal"
				outline-danger
				:primary="false"
				:loading="isDeleting"
				:disable="isDeleting"
			/>
		</template>
	</SOSlotBase>
</template>

<script>
import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOEmptySearchState from "@/so-components/global/ui/SOEmptySearchState.vue";
import SOEmptyState from "@/so-components/global/ui/SOEmptyState.vue";
import SOLoadingPage from "@/so-components/global/ui/SOLoadingPage.vue";
import SOLoadMoreLoading from "@/so-components/global/ui/SOLoadMoreLoading.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";
import metaAPI from '@/store/utils/api-route/metaAPI';
import conn from '@/store/utils/connection';
import SOButton from '@/so-components/global/ui/SOButton.vue';
import SOModalConfirm from '@/so-components/global/modal/SOModalConfirm.vue';

export default {
  name: "ActiveSession",
  components: {
    SOSlotBase,
    SOTitleBar,
    SOLoadingPage,
    SOEmptySearchState,
    SOEmptyState,
    SOLoadMoreLoading,
    SOButton,
    SOModalConfirm,
  },

  data() {
    return {
      isLoading: false,
      isLoadingMore: false,
	  isDeleting: false,
	  deleteBody: '',
      key: "",
	  data: [],
	  count: 0,
	  param: {
		limit: 20,
		offset: 0,
	  }
    };
  },

  async mounted() {
    await this.getData();
  },

  methods: {
	formattedDate(date) {
		return this.$moment(date).format('DD-MM-YYYY HH:mm')
	},
	async getData(loadMore = false) {
		try {
			if (!loadMore) {
				this.data = []
				this.param.offset = 0
			}
			this.isLoading = !loadMore
			const res = await conn.get(metaAPI.ownerToken, this.param)
			const data = res.data.data

			this.count = data.count
			this.data.push(...data.item)
			
			if (data.item.length == 20) {
				this.param.offset += 20
			}
			this.isLoading = false
		} catch (error) {
			this.isLoading = false
			this.$toast.error(error?.message)
		}
	},
	async logoutSession(id, lastLogin) {
		const isAll = id == 'all'
		this.deleteBody = isAll ? 'apakah anda yakin ingin menghapus seluruh sesi?' : `apakah anda yakin ingin menghapus sesi dengan login terakhir ${this.formattedDate(lastLogin)}?`
		this.$refs.deleteConfirmModal.open().then((v) => {
			if (v) {
				this.isDeleting = true
				return conn.del(`${metaAPI.ownerToken}/${id}`)
			} else {
				throw new Error(0)
			}
		})
		.then(() => {
			this.getData()
			this.$toast.success(isAll ? 'Berhasil menghapus semua sesi' : 'Berhasil logout')
			this.$refs.deleteConfirmModal.close()
			if (isAll) {
				this.$router.replace('dashboard')
			}
		}).catch(e => {
			(e.message != 0) && this.$toast.error(`Gagal menghapus sesi. (${e})`)
		}).finally(() => {
			this.isDeleting = false
		})
	},
    back() {
      this.$router.go(-1);
    },
  },
};
</script>
<style scoped>
.elipsis {
	word-break: break-word;
	overflow-wrap: break-word;
}
</style>
